(function () {

  'use strict';

  angular.module('AddPrinter')
    .controller('AddPrinterController', function (
      $scope, $location, URLS, $filter, PrinterListService, PRINTER_TYPES,
      toastr, NetworkListService, NetworkListPaging, EventHandlerService,
      SnmpConfigurationService, TenantListService, $rootScope) {

      $scope.me = null;
      $scope.printerTypes = PRINTER_TYPES;
      $scope.printer = {
        ipAddress: null,
        type: PRINTER_TYPES.NETWORK,
        name: null
      };
      $scope.printerInputFieldFocusKey = 'printerInputFieldFocusKey';
      $scope.selectedNetwork = null;
      $scope.networkListService = NetworkListService;
      $scope.networkListPaging = new NetworkListPaging();
      $scope.waitingForAnswer = false;
      $scope.disableSubmitBtn = true;
      $scope.snmpConfigurationsList = null;
      $scope.snmpConfigResource = null;
      $scope.defaultSnmpConfiguration = null;
      $scope.selectedSnmpConfig = null;
      $scope.tenantListService = null;
      $scope.helpCaption = 'HelpAddPrinter';
      $scope.error = null;

      $scope.$watch(function () {
        return TenantListService.currentTenant;
      }, function () {
        if (TenantListService.currentTenant) {
          $scope.tenantListService = TenantListService;
        }
      }, true);

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      $scope.$watch(function () {
        return $scope.defaultSnmpConfiguration;
      }, function () {
        if ($scope.defaultSnmpConfiguration && !$scope.selectedSnmpConfig) {
          setSelectedSnmpConfigurationToDefault();
        }
      });

      function getDefaultSnmpConfiguration() {
        SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
          $scope.defaultSnmpConfiguration = defaultSnmpConfiguration;
        }).catch(function (error) {
          // handle error
        });
      }

      function setSelectedSnmpConfigurationToDefault() {
        $scope.selectedSnmpConfig = $scope.defaultSnmpConfiguration;
        $scope.snmpConfigResource = $scope.defaultSnmpConfiguration;
      }

      (function () {
        initEventHandler();
        getDefaultSnmpConfiguration();
      })();

      function initEventHandler() {
        EventHandlerService.deRegisterListeners();
      }

      function isSnmpConfigurationValidForNetwork() {
        const snmp = $scope.selectedSnmpConfig;
        if (!snmp || !snmp.info.networkIds || !snmp.info.networkIds.length) {
          return true;
        }
        const network = $scope.selectedNetwork;
        if (network && snmp.info.networkIds.includes(network.customProperties.id)) {
          return true;
        }
        return false;
      }

      $scope.setSelectedNetwork = function (network) {
        if (network) {
          $scope.selectedNetwork = network;
          if (!$scope.selectedSnmpConfig || !isSnmpConfigurationValidForNetwork()) {
            setSelectedSnmpConfigurationToDefault();
          }
        }
      };

      $scope.changePrinterSnmpConfiguration = function (snmpConfig) {
        $scope.selectedSnmpConfig = snmpConfig;
        $scope.printer.snmpConfiguration = snmpConfig.info._links.self.href;
        getSnmpConfiguration(snmpConfig.info._links.self.href);
      };

      function getSnmpConfiguration(snmpConfigUrl) {
        SnmpConfigurationService.getSnmpConfigurationByUrl(snmpConfigUrl).then(function (response) {
          $scope.snmpConfigResource = response;
        }).catch(function (error) {
          // handle error
        });
      }

      $scope.addPrinter = function (form, $event) {
        $scope.waitingForAnswer = true;
        if ($scope.printer.type !== PRINTER_TYPES.FREEDOM) {
          $scope.printer.networkId = $scope.selectedNetwork.info._links.self.href;
        } else {
          delete $scope.printer.networkId;
        }

        PrinterListService.createPrinter($scope.printer).then(function () {
          $scope.waitingForAnswer = false;
          $location.path(URLS.PRINTER_LIST);
          toastr.success($filter('translate')('WorkingOnIt'));
        }).catch(function (error) {
          $scope.error = error;
          $scope.waitingForAnswer = false;
        });
      };

      $scope.isButtonDisable = function (form) {
        if ($scope.printer.type === 'FREEDOM') {
          $scope.printer.ipAddress = null;
          $scope.selectedNetwork = null;
          return !$scope.printer.name;
        } else {
          $scope.printer.name = null;
          return !$scope.printer.ipAddress || !$scope.selectedNetwork;
        }
      };

      $scope.networkSelectPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.networkListPaging.pagingCriteria.pageSize = 5;
        $scope.networkListPaging.pagingCriteria.match = null;

        $scope.networkSelectConfiguration = {
          paginationObject: $scope.networkListPaging,
          placeholderText: 'Search',
          service: 'NetworkListService',
          contentHeight: 463
        };

        $scope.networkSelectPopupObject = {
          dimensions: { height: 463, width: 400 },
          offset: { top: 22, left: 60 },
          pointerDirection: 'down',
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          context: 'selectNetwork',
          type: 'PAGINATION',
          title: 'SelectNetwork',
          confirmText: 'SelectNetwork',
          clickOutsideToClose: true
        };
      };

      $scope.snmpSelectPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.snmpConfigurationSelectConfiguration = {
          network: $scope.selectedNetwork || null
        };

        $scope.snmpConfigurationSelectPopupObject = {
          dimensions: { width: 400 },
          offset: { top: 0, left: 0 },
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          context: 'selectSnmpConfiguration',
          type: 'SELECT_SNMP',
          title: 'SelectSnmpConfiguration',
          confirmText: 'SelectSnmpConfiguration',
          clickOutsideToClose: true
        };
      };

      $scope.clearPopups = function () {
        $scope.networkSelectConfiguration = null;
        $scope.networkSelectPopupObject = null;

        $scope.snmpConfigurationSelectPopupObject = null;
        $scope.snmpConfigurationSelectConfiguration = null;
      };

      $scope.clearError = function () {
        $scope.error = null;
      };

    });
})();
